import queryString, { type ParsedQuery, type ParseOptions, type StringifyOptions } from 'query-string';

export { type ParsedQuery, type ParseOptions, type StringifyOptions };
export const safeQueryString = {
  fromString(value: string, options?: ParseOptions): ParsedQuery {
    return queryString.parse(value, options);
  },
  toString(value: Record<string, any>, options?: StringifyOptions): string {
    return queryString.stringify(value, options);
  }
};
